<template>
  <div>
    <a-form :layout="formLayout" :form="form">
      <a-form-item :wrapper-col="buttonItemLayout.wrapperCol">
        <h3>基本信息：</h3>
      </a-form-item>
      <a-form-item
        label="手机号"
        :label-col="formItemLayout.labelCol"
        :wrapper-col="formItemLayout.wrapperCol"
      >
        <a-input
          allowClear
          v-decorator="[
            'phone',
            {
              initialValue: phone,
              rules: [{ required: true, min: 11,max:11, message: '手机号必须为11位' }]
            }
          ]"
          placeholder="请输入手机号"
        />
      </a-form-item>

      <a-form-item
        label="身份证号码"
        :label-col="formItemLayout.labelCol"
        :wrapper-col="formItemLayout.wrapperCol"
      >
        <a-input
          allowClear
          v-decorator="[
            'id_code',
            {
              initialValue: id_code,
              rules: [{ required: true, min: 1, message: '请输入身份证号' }]
            }
          ]"
          placeholder="请输入"
        />
      </a-form-item>

      <a-form-item
        label="真实姓名"
        :label-col="formItemLayout.labelCol"
        :wrapper-col="formItemLayout.wrapperCol"
      >
        <a-input
          allowClear
          v-decorator="[
            'name',
            {
              initialValue: name,
              rules: [{ required: true, min: 1,max:20, message: '姓名（1-20位）' }]
            }
          ]"
          placeholder="请输入姓名"
        />
      </a-form-item>

      <a-form-item
        label="性别"
        :label-col="formItemLayout.labelCol"
        :wrapper-col="formItemLayout.wrapperCol"
      >
        <a-select
          v-decorator="[
            'sex',
            {
              initialValue: sex,
            }
          ]"
          style="width: 120px"
        >
          <a-select-option value="0">男</a-select-option>
          <a-select-option value="1">女</a-select-option>
          <a-select-option value="-1">未知</a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item :wrapper-col="buttonItemLayout.wrapperCol">
        <h3>认证信息：</h3>
        <a-button type="primary" @click="addAnnex">增加认证信息</a-button>
      </a-form-item>
      <div v-for="i in count">
        <div style="background-color:#E8E8E8;margin-top:50px" v-if="closeList.indexOf(i)===-1">
          <!-- Success Description -->
          <!-- <span style="color: red">Success</span> Description Success Description -->
          <a-icon
            :style="{ fontSize: '16px', color: '#1296db' ,margin:'20px'}"
            type="close"
            @click="closeAnnex(i)"
          />
          <a-form-item
            label="认证信息名称"
            :label-col="formItemLayout.labelCol"
            :wrapper-col="formItemLayout.wrapperCol"
          >
            <a-input
              placeholder="请输入"
              allowClear
              v-decorator="['title_'+i,{initialValue:annexs[i-1]?annexs[i-1].title:''}]"
            />
          </a-form-item>

          <a-form-item
          extra="  "
            label="认证信息介绍"
            :label-col="formItemLayout.labelCol"
            :wrapper-col="formItemLayout.wrapperCol"
          >
            <a-textarea
              :autosize="{ minRows: 6, maxRows: 20 }"
              placeholder="请输入"
              allowClear
              v-decorator="['introduce_'+i,{initialValue:annexs[i-1]?annexs[i-1].introduce:''}]"
            />
          </a-form-item>

          <a-form-item
            label="附件资料"
            :label-col="formItemLayout.labelCol"
            :wrapper-col="formItemLayout.wrapperCol"
          >
            <!-- :fileList="annexs[i-1].annexs" -->
            <!-- :defaultFileList="annexs[i-1].annexs" -->
              <!-- v-decorator="['annex_'+i,{initialValue:annexs[i-1].introduce}]" -->
            <!-- getValueFromEvent: normFile, -->
            <a-upload
                :data="file_data"
              :defaultFileList="annexs[i-1]?annexs[i-1].annexs:[]"
             v-decorator="['annex_'+i,{
            initialValue:annexs[i-1]?annexs[i-1].annexs:[]
             }]"
              name="file"
              :multiple="true"
              :action="uploadURL+i"
              :withCredentials="withCredentials"
              :headers="headers"
              @change="handleChange"
            >
              <a-button>
                <a-icon type="upload" />点击上传
              </a-button>
            </a-upload>
          </a-form-item>
        </div>
      </div>

      <a-form-item :wrapper-col="buttonItemLayout.wrapperCol">
        <a-button type="primary" @click="handleSubmit">点击保存</a-button>
      </a-form-item>
    </a-form>
  </div>
</template>

<script>
import request from "../../utils/request";
import Global from "../../global_variable";

export default {
  data() {
    return {
        uploadURL:Global.uploadURL,
      formLayout: "horizontal",
      form: this.$form.createForm(this),
      old: {},
      phone: "",
      id_code: "",
      name: "",
      sex: "-1",
      //设置上传的请求头部，IE10 以上有效
      headers: {
        authorization: "authorization-text"
      },
        file_data:{
            authority:500
        },
      //上传请求时是否携带 cookie
      withCredentials: true,
      count: 0,
      annexs: [],
      closeList: [],
    };
  },
  mounted() {
    this.getData();
  },
  computed: {
    formItemLayout() {
      const { formLayout } = this;
      return formLayout === "horizontal"
        ? {
            labelCol: { span: 4 },
            wrapperCol: { span: 14 }
          }
        : {};
    },
    buttonItemLayout() {
      const { formLayout } = this;
      return formLayout === "horizontal"
        ? {
            wrapperCol: { span: 14, offset: 4 }
          }
        : {};
    }
  },
  methods: {
    normFile(e) {
      console.log('Upload event:', e);
      if (Array.isArray(e)) {
        return e;
      }
      return e && e.fileList;
    },
    getData() {
      request({
        url: "/doctor/" + this.$route.query.the_id,
        method: "get",
        params: {}
      }).then(response => {
        let data = response.data;
        if (data.success) {
          // this.form.resetFields();
          this.old = data.data;
          this.phone = data.data.phone;
          this.id_code = data.data.id_code;
          this.name = data.data.name;
          this.sex = data.data.sex + "";
          this.annexs = data.data.items;
          console.log("看看annexs",this.annexs);
          this.count = data.data.items.length;
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    handleChange(info) {
      // this.fileList = [...info.fileList];
      console.log("info", info);
      if (info.file.status === "removed") {
      }
      if (info.file.status !== "uploading") {
        console.log(info.file, info.fileList);
      }
      if (info.file.status === "done") {
        this.$message.success(`${info.file.name} file uploaded successfully`);
        console.log("完成", info.file, info.fileList);
      } else if (info.file.status === "error") {
        this.$message.error(`${info.file.name} file upload failed.`);
      }
    },

    handleCancel() {
      this.previewVisible = false;
    },
    handlePreview(file) {
      this.previewImage = file.url || file.thumbUrl;
      this.previewVisible = true;
    },
    handleFormLayoutChange(e) {
      this.formLayout = e.target.value;
    },
    closeAnnex(i) {
      console.log("关闭嗯", i);
      this.closeList.push(i);
    },
    addAnnex() {
      this.count += 1;
    },
    handleSubmit() {
      this.form.validateFields((err, values) => {
        console.log("第一步",values)
        if (!err) {
          for (let i = 1; i <= this.count; i++) {
            console.log("看卡" + i, values);
            if (this.closeList.indexOf(i) !== -1) {
              values["title_" + i] = "";
              values["introduce_" + i] = "";
              values["annex_" + i] = "";
            } else {
              let annex = values["annex_" + i];
              if (annex) {
                if(annex.fileList){
                  annex=annex.fileList;
                }
                values["annex_" + i] = annex.map(x => {
                  console.log("内部x", x, x.response);
                  if(x.response){
                    return x.response;
                  }
                  return x;
                });
              } else {
                values["annex_" + i] = "";
              }
            }
          }
          console.log(this.form);
          console.log(values);
          values["count"] = this.count;

          request({
            url: "/doctor/" + this.$route.query.the_id,
            method: "PUT",
            data: values
          }).then(response => {
            let data = response.data;
            if (data.success) {
              this.form.resetFields();
              this.$message.success(data.msg);
              this.$router.push({ path: "/doctor/all" });
            } else {
              this.$message.error(data.msg);
            }
            console.log(response);
          });
        }
      });
    }
  }
};
</script>
